import { panasAnsewerType } from "../questionnaireComponents/Panas";
import { apiEndPoint } from "./endPoint";
import { godSpeedType } from "./GodSpeed";

export const putFirstDayAnswer = async (
  userId: string,
  date: string,
  answer: {
    panas: panasAnsewerType;
    godspeed?: godSpeedType;
  },
  token: string
) => {
  const url = `${apiEndPoint}/putPanasData`;

  const putData = {
    userId: userId,
    date: date,
    answer: answer,
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(putData),
    });

    if (response.ok) {
      const responseData = await response.json();
      console.log(response);
      return responseData;
    } else {
      throw new Error("Failed to fetch");
    }
  } catch (err) {
    console.error("Error:", err);
    return {
      role: "error",
      content: "エラーが発生したようです。初めからやり直してください。",
    };
  }
};
